<div class="title">Option Editor</div>
<div class="work-space">
  <app-attribute-option-editor #editor [project]="project" [attribute]="attribute" [option]="option">
  </app-attribute-option-editor>
</div>
<div class="footer">
  <button type="button" (click)="Ok()" class="btn btn-sm btn-primary">Ok</button>
  <button type="button" (click)="Cancel()" class="btn btn-sm btn-primary">Cancel</button>
</div>
